/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Observable } from "rxjs";


export class LazyLoadManager {

  lazyLoadData: any[] = [];

  recordLoadLimit: number = 50;
  startingRecord: number = 0;
  endingRecord: number = this.recordLoadLimit - 1;

  constructor(data: any[], limit: number = 50) {
    this.recordLoadLimit = limit;
    this.endingRecord = this.recordLoadLimit - 1;
    this.lazyLoadData = data == null ? [] : data;
  }

  processData(moveToFirst: boolean): Observable<any> {
    var dataToLoad = [];
    try {
      if (this.lazyLoadData.length == 0) throw "Lazy data empty.";

      if (moveToFirst) {
        this.startingRecord = 0;
        this.endingRecord = this.recordLoadLimit;
      }
      else {
        this.startingRecord = this.endingRecord;
        this.endingRecord += this.recordLoadLimit;
      }

      if (this.endingRecord > this.lazyLoadData.length) {
        this.endingRecord = this.lazyLoadData.length - 1;
        if (!moveToFirst)
          return Observable.throw("No more records.");
      }

      dataToLoad = this.lazyLoadData.splice(this.startingRecord, this.recordLoadLimit);
    }
    catch (e) {
      return Observable.throw("Unable to process data for lazy loading. " + e);
    }
    return Observable.of(dataToLoad);
  }
}
